window.BeyondTruckFitMap = window.BeyondTruckFitMap || {"4499692257360":{"129":[7.4,7.8],"139":[7.8,8.2],"144":[8.2,8.375],"149":[8.375,8.6],"159":[8.6,9],"169":[9,9.5]},"4499692519504":{"109":[6.25,7.6],"129":[7.4,7.8],"139":[7.8,8.2],"144":[8.2,8.375],"149":[8.375,8.6],"159":[8.6,9],"169":[9,9.5],"215":[9.5,10.5]},"4499692814416":{"5 Mid":[6,7.9],"5.25 Mid":[7.9,8.1],"5.6":[8.1,8.3],"5.8":[8.4,8.6],"6.1":[8.62,9]},"4499692978256":{"148":[8.12,8.38],"149":[8.38,8.62],"151":[8.62,8.85],"161":[8.9,9.5],"145 Mid":[7.4,7.9],"147 Mid":[7.9,8.12]},"4499693142096":{"149":[8.38,8.62],"145 Low":[7.4,7.9],"145 Mid":[7.4,7.9],"147 Low":[7.9,8.12],"147 Mid":[7.9,8.12],"148 Mid":[8.12,8.38],"151 Mid":[8.62,8.85]},"4499693273168":{"143":[6,7.4],"149":[8.38,8.62],"151":[8.62,8.85],"161":[8.9,9.5],"145 Low":[7.4,7.9],"145 Mid":[7.4,7.9],"147 Mid":[7.9,8.12],"148 Mid":[8.12,8.38]},"4499693371472":{"145":[7.4,7.9],"147":[7.9,8.12],"148":[8.12,8.38],"149":[8.38,8.62]},"4499765821520":{"22 5.0":[7.625,7.625],"33 5.375":[7.75,8.12],"44 5.75":[8.12,8.5],"55 6.375":[8.5,9.12],"66 9.35":[9.375,9.375]},"6631414169770":{"80":[10,10],"33 5.375":[8,8],"44 5.75":[8.25,8.5],"55 6.375":[8.5,8.75],"60 8.75":[8.75,8.75],"66 9.35":[9,9.25]},"7703422238890":{"80":[10,10],"33 5.375":[8,8],"44 5.75":[8.25,8.5],"55 6.375":[8.5,8.75],"60 8.75":[8.75,8.75],"66 9.35":[9,9.25]},"7793906024618":{"139":[7.8,8.2],"144":[8.2,8.375],"149":[8.375,8.6],"159":[8.6,9],"169":[9,9.5]},"8052861272234":{"147":[7.9,8.12],"148":[8.12,8.38],"149":[8.38,8.62]},"8068457169066":{"146":[8.125,8.625],"151":[8.375,8.875],"166":[8.5,9.5]},"8089033670826":{"149":[8.375,8.6]},"8095669944490":{"8.25":[8,8.5],"8.50":[8.25,8.75]},"8120702304426":{"10":[9.75,10.25]},"8120702337194":{"11.00":[10.75,11.25]},"8123340816554":{"8.0":[8,8],"8.25":[8.25,8.25],"8.50":[8.5,8.5]},"8218453213354":{"8.0":[7.75,8.25],"8.25":[8,8.5],"8.50":[8.25,8.75]},"8226622374058":{"44 5.75":[8.25,8.5],"55 6.375":[8.5,8.75],"66 9.35":[9,9.25]},"8291545383082":{"149":[8.375,8.6],"159":[8.6,9],"169":[9,9.5]},"8295373701290":{"147":[7.9,8.12],"148":[8.12,8.38],"149":[8.38,8.62]},"8365944078506":{"5.25":[7.9,8.1],"5.6":[8.1,8.3],"5.8":[8.4,8.6],"6.1":[8.62,9]},"8403455410346":{"8.25":[8.25,8.25]},"8411739979946":{"10.0":[9.75,10.25]},"8411740012714":{"10.0":[9.75,10.25]},"8411740471466":{"8.25":[8,8.5],"8.50":[8.25,8.75]},"8415968460970":{"144":[8.2,8.375],"149":[8.375,8.6]},"8436613316778":{"8.0":[8,8]},"8442218086570":{"5.25":[7.9,8.1],"5.6":[8.1,8.3]},"8442806370474":{"8.25":[8,8.5]},"8442806403242":{"8.25":[8,8.5]},"8446555553962":{"5.25":[7.9,8.1],"5.6":[8.1,8.3]},"8446555652266":{"148":[8.12,8.38],"149":[8.38,8.62]},"8446555685034":{"148":[8.12,8.38],"149":[8.38,8.62]},"8453367627946":{"5.6":[8.1,8.3]},"8453379293354":{"5.6":[8.1,8.3]},"8453380243626":{"8.25":[8.25,8.25]},"8453380276394":{"8.25":[8.25,8.25]},"8453380702378":{"8.0":[8,8],"8.25":[8.25,8.25],"8.50":[8.5,8.5]},"8454654787754":{"5.25":[7.9,8.1],"5.6":[8.1,8.3]},"8626783518890":{"12.0":[11.75,12.25],"13.0":[12.75,13.25]},"8626784207018":{"11.0":[10.75,11.25]},"8626784239786":{"10.5":[10.25,10.75],"11.0":[10.75,11.25]},"8628612530346":{"149":[8.375,8.6],"159":[8.6,9]},"8633919766698":{"10.0":[9.75,10.25]},"15420530884778":{"8.0":[7.75,8.25],"8.25":[8,8.5],"8.5":[8.25,8.75]},"15420530917546":{"8.25":[8,8.5],"8.5":[8.25,8.75]}};
window.BeyondTruckVendors={"4499692257360":"Independent","4499692519504":"Independent","4499692814416":"Venture","4499692978256":"Thunder","4499693142096":"Thunder","4499693273168":"Thunder","4499693371472":"Thunder","4499765821520":"Ace","6631414169770":"Ace","7703422238890":"Ace","7793906024618":"Independent","8052861272234":"Thunder","8068457169066":"Independent","8089033670826":"Independent","8095669944490":"Slappy Trucks","8120702304426":"Slappy Trucks","8120702337194":"Slappy Trucks","8123340816554":"Grind King","8218453213354":"Slappy Trucks","8226622374058":"Ace","8291545383082":"Independent","8295373701290":"Thunder","8365944078506":"Venture","8403455410346":"Silver","8411739979946":"Slappy Trucks","8411740012714":"Slappy Trucks","8411740471466":"Slappy Trucks","8415968460970":"Independent","8436613316778":"Grind King","8442218086570":"Venture","8442806370474":"Slappy Trucks","8442806403242":"Slappy Trucks","8446555553962":"Venture","8446555652266":"Thunder","8446555685034":"Thunder","8453367627946":"Venture","8453379293354":"Venture","8453380243626":"Silver","8453380276394":"Silver","8453380702378":"Silver","8454654787754":"Venture","8626783518890":"Slappy Trucks","8626784207018":"Slappy Trucks","8626784239786":"Slappy Trucks","8628612530346":"Independent","8633919766698":"Slappy Trucks","15420530884778":"Slappy Trucks","15420530917546":"Slappy Trucks"};
if (!window.beyondSaleFilterBound) {
  window.beyondSaleFilterBound = true;
  document.addEventListener('input', event => {
    const toggle = event.target;
    if (!toggle.matches('[data-beyond-sale-toggle]')) return;
    const group = toggle.closest('.beyond-sale-filter');
    const form = toggle.closest('form');
    form.querySelectorAll('input[type="checkbox"][name]').forEach(input => {
      if (input.name === group.dataset.saleParam) input.checked = toggle.checked;
    });
    group.querySelectorAll('[data-beyond-sale-value]').forEach(input => { input.disabled = !toggle.checked; });
  }, true);
}

if (!window.beyondSizeBound) {
  window.beyondSizeBound = true;
  const key = scope => 'beyond-size-v1-' + scope;
  const shoeGroup = raw => {
    const value = raw.trim();
    let match = value.match(/^W\s*-?\s*(\d+(?:\.\d+)?)$/i);
    if (match) return { group: "Women’s US", label: match[1], order: 1 };
    match = value.match(/^Y\s*-?\s*(\d+(?:\.\d+)?)$/i);
    if (match) return { group: "Kids’ US", label: match[1], order: 2 };
    match = value.match(/^T\s*-?\s*(\d+(?:\.\d+)?)$/i);
    if (match) return { group: "Toddlers", label: match[1], order: 3 };
    if (/^\d+(?:\.\d+)?$/.test(value)) return { group: "Men’s US", label: value, order: 0 };
    return { group: "Other sizes", label: value, order: 4 };
  };
  const clothingScope = select => ['clothing','mixed','mixed-general'].includes(select.dataset.sizeScope);
  const multiSizeScope = select => clothingScope(select) || select.dataset.sizeScope === 'footwear';
  const sizeSelectionLabel = (select, value) => {
    if (select.dataset.sizeScope !== 'footwear') return value;
    const option = [...select.options].find(option => option.value === value);
    return option ? (option.dataset.sizeGroup || shoeGroup(value).group) + ' ' + option.textContent : value;
  };
  const foldYouthFour = select => {
    if (select.dataset.sizeScope !== 'footwear') return;
    const inputs = [...select.closest('form').querySelectorAll('input[type="checkbox"][name]')].filter(input => input.name === select.dataset.sizeParam);
    [...select.options].filter(option => /^\d+(?:\.\d+)?$/.test(option.value) && +option.value < 4).forEach(option => option.remove());
    const members = inputs.filter(input => /^(?:Y\s*-?\s*)?4(?:\.0+)?$/i.test(input.value));
    if (!members.length) return;
    [...select.options].filter(option => /^Y\s*-?\s*4(?:\.0+)?$/i.test(option.value) || option.value === '__youth_4').forEach(option => option.remove());
    const option = document.createElement('option');
    option.value = '__youth_4';
    option.textContent = '4';
    option.dataset.sizeLabel = 'Y-4';
    option.dataset.sizeValues = JSON.stringify([...new Set(members.map(input => input.value))]);
    option.disabled = members.every(input => input.disabled);
    select.append(option);
  };
  const letterParts = raw => {
    const aliases = {XXL:'2XL',XXXL:'3XL'};
    const parts = raw.trim().toUpperCase().replace(/\s/g,'').split(/[\/-]/);
    if (parts.at(-1) === 'TALL') parts.pop();
    if (!parts.length || !parts.every(part => /^(XXXS|XXS|XS|S|M|L|XL|XXL|2XL|XXXL|3XL|4XL|5XL)$/.test(part))) return [];
    return [...new Set(parts.map(part => aliases[part] || part))];
  };
  const foldTallSizes = select => {
    if (!clothingScope(select)) return;
    const form = select.closest('form');
    const inputs = [...form.querySelectorAll('input[type="checkbox"][name]')].filter(input => input.name === select.dataset.sizeParam);
    const members = new Map();
    inputs.forEach(input => letterParts(input.value).forEach(letter => {
      if (!members.has(letter)) members.set(letter, []);
      members.get(letter).push(input);
    }));
    [...select.options].filter(option => option.dataset.clothingLetter || letterParts(option.value).length).forEach(option => option.remove());
    members.forEach((items, letter) => {
      const option = document.createElement('option');
      option.value = letter;
      option.textContent = letter;
      option.dataset.sizeLabel = letter;
      option.dataset.clothingLetter = '';
      option.dataset.sizeValues = JSON.stringify([...new Set(items.map(input => input.value))]);
      option.disabled = items.every(input => input.disabled);
      select.append(option);
    });
    const active = [...new Set(inputs.filter(input => input.checked).map(input => input.value))];
    let requested = [];
    try { requested = JSON.parse(new URLSearchParams(location.search).get('b_clothing_sizes') || '[]'); } catch {}
    const choices = [...select.options].filter(option => option.value && option.value !== '__multiple');
    requested = Array.isArray(requested) ? requested.filter(value => choices.some(option => option.value === value)) : [];
    const rawValues = values => [...new Set(values.flatMap(value => {
      const option = choices.find(option => option.value === value);
      return JSON.parse(option?.dataset.sizeValues || JSON.stringify([value]));
    }))];
    const requestedRaw = rawValues(requested).filter(value => inputs.some(input => input.value === value && !input.disabled));
    const exact = requestedRaw.length === active.length && active.every(value => requestedRaw.includes(value));
    const selected = exact ? requested : [...new Set(active.flatMap(value => letterParts(value).length ? letterParts(value) : [value]))].filter(value => choices.some(option => option.value === value));
    select.dataset.clothingSelection = JSON.stringify(selected);
    select.value = selected[0] || '';
    let hidden = form.querySelector('[data-clothing-size-input]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'b_clothing_sizes';
      hidden.dataset.clothingSizeInput = '';
      form.append(hidden);
    }
    hidden.value = JSON.stringify(selected);
    hidden.disabled = !selected.length;
  };
  const clothingGroup = raw => {
    const value = raw.trim();
    const upper = value.toUpperCase();
    const letters = ['XXXS','XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL'];
    const letter = upper.match(/^(XXXS|XXS|XS|S|M|L|XL|XXL|2XL|XXXL|3XL|4XL|5XL)(?:\s*(?:\/|-)\s*(?:TALL|XS|S|M|L|XL|XXL))?$/);
    if (letter) return {group:'Letter sizes',label:value,order:0,rank:letters.indexOf(letter[1])};
    if (/^\d{2}$/.test(value) && +value >= 24 && +value <= 60)
      return {group:'Waist sizes',label:value,order:1,rank:+value};
    const pair = value.match(/^(\d{2})\s*\/\s*(\d{2})$/);
    if (pair && +pair[1] >= 24 && +pair[1] <= 60 && +pair[2] >= 28 && +pair[2] <= 38)
      return {group:'Waist / length',label:value,order:2,rank:+pair[1]*100 + +pair[2]};
    const youth = upper.match(/^Y\s*-?\s*(XS|S|M|L|XL|\d+)$/);
    if (youth) return {group:'Youth sizes',label:value,order:3,rank:/^\d+$/.test(youth[1]) ? +youth[1]+10 : ['XS','S','M','L','XL'].indexOf(youth[1])};
    return {group:'Other sizes',label:value,order:4,rank:0};
  };
  const mixedGroup = (raw, safe) => {
    const clothing = clothingGroup(raw);
    if (clothing.group !== 'Other sizes') return clothing;
    const shoe = shoeGroup(raw);
    if (safe && shoe.group !== 'Other sizes') return {...shoe,group:'Footwear · ' + shoe.group,order:5 + shoe.order};
    if (/^\d+(?:\.\d+)?$/.test(raw.trim())) return {group:'Numbered sizes',label:raw,order:5};
    return clothing;
  };
  const groupFootwearSizes = select => {
    if (!['footwear','clothing','mixed','mixed-general','decks','completes'].includes(select.dataset.sizeScope)) return;
    const selected = select.value;
    const options = Array.from(select.options);
    const groups = new Map();
    const fragment = document.createDocumentFragment();
    options.filter(option => !option.value || option.value === '__multiple').forEach(option => fragment.append(option));
    options.filter(option => option.value && option.value !== '__multiple')
      .map(option => ({ option, info: (select.dataset.sizeScope === 'footwear' ? shoeGroup : ['decks','completes'].includes(select.dataset.sizeScope) ? value => ({group:select.dataset.sizeScope==='completes' && /^\d+(?:\.\d+)?$/.test(value) && +value>=20 && +value<=60?'Board length':'Other sizes',label:value,order:0}) : select.dataset.sizeScope.startsWith('mixed') ? value => mixedGroup(value, select.dataset.sizeScope === 'mixed') : clothingGroup)(option.dataset.sizeLabel || option.value) }))
      .sort((a,b) => a.info.order - b.info.order || (a.info.rank || 0) - (b.info.rank || 0) || a.info.label.localeCompare(b.info.label, undefined, {numeric:true}))
      .forEach(({option,info}) => {
        if (!groups.has(info.group)) {
          const group = document.createElement('optgroup'); group.label = info.group;
          groups.set(info.group, group); fragment.append(group);
        }
        option.textContent = info.label;
        option.dataset.sizeGroup = info.group;
        groups.get(info.group).append(option);
      });
    select.replaceChildren(fragment);
    select.value = selected;
  };
  const deckNumber = raw => {
    const match = raw.trim().match(/^(\d+(?:\.\d+)?)(?:\s*(?:"|in|inch|Short))?$/i);
    return match && +match[1] >= 5 && +match[1] <= 16 ? +match[1] : null;
  };
  const groupDeckSizes = select => {
    if (select.dataset.hasDecks !== 'true' || select.dataset.hasFootwear === 'true') return;
    const options = [...select.options].filter(o => o.value && o.value !== '__multiple');
    const decks = options.filter(o => deckNumber(o.value) !== null || o.dataset.deckRange);
    if (!decks.length) return;
    const inputs = [...select.closest('form').querySelectorAll('input[type="checkbox"][name]')].filter(i=>i.name === select.dataset.sizeParam);
    const active = inputs.filter(i=>i.checked).map(i=>i.value);
    const bands = [
      {label:'Under 7.5″',test:n=>n<7.5},
      {label:'7.5–8.0″',test:n=>n>=7.5&&n<=8},
      {label:'Over 8–8.25″',test:n=>n>8&&n<=8.25},
      {label:'Over 8.25–8.5″',test:n=>n>8.25&&n<=8.5},
      {label:'Over 8.5–9″',test:n=>n>8.5&&n<=9},
      {label:'Over 9–10″',test:n=>n>9&&n<=10},
      {label:'Over 10″',test:n=>n>10}
    ];
    // Only broad deck collections need ranges. Smaller brand selections keep exact widths.
    if (['decks','completes'].includes(select.dataset.sizeScope) && decks.length > 12 && !decks.some(o=>o.dataset.deckRange)) {
      bands.forEach(band => {
        const members = decks.filter(o=>band.test(deckNumber(o.value)));
        if (!members.length) return;
        const option = members[0];
        option.dataset.deckRange = band.label;
        option.dataset.sizeValues = JSON.stringify(members.map(o=>o.value));
        option.disabled = members.every(o=>o.disabled);
        members.slice(1).forEach(o=>o.remove());
        if(active.length && active.every(v=>members.some(o=>o.value===v))) select.value=option.value;
      });
    }
    [...select.options].forEach(option => {
      const width = deckNumber(option.value);
      if (width === null && !option.dataset.deckRange) return;
      option.dataset.sizeGroup = 'Deck width';
      option.textContent = option.dataset.deckRange || width + '″' + (/Short/i.test(option.value)?' Short':'');
    });
  };

  const groupTruckSizes = select => {
    if(select.dataset.sizeScope !== 'trucks') return;
    const form=select.closest('form'), param=select.dataset.sizeParam;
    const inputs=[...form.querySelectorAll('input[type="checkbox"][name]')].filter(i=>i.name===param);
    const active=inputs.filter(i=>i.checked).map(i=>i.value);
    [...select.options].filter(o=>o.dataset.fitWidth).forEach(o=>o.remove());
    const raw=[...select.options].filter(o=>o.value && o.value!=='__multiple');
    raw.forEach(o=>{o.dataset.sizeGroup='Truck size';});
    const aliases=raw.filter(o=>/^5\.2(?:5)?(?:\s+(?:Low|Mid|Hi|High))?$/i.test(o.value));
    if(aliases.length){
      const o=aliases[0];o.textContent='5.2 / 5.25';o.dataset.sizeValues=JSON.stringify(inputs.filter(i=>/^5\.2(?:5)?(?:\s+(?:Low|Mid|Hi|High))?$/i.test(i.value)).map(i=>i.value));
      o.disabled=aliases.every(x=>x.disabled);aliases.slice(1).forEach(x=>x.remove());
      if(active.length && active.every(v=>JSON.parse(o.dataset.sizeValues).includes(v)))select.value=o.value;
    }
    const widths=[7,7.25,7.5,7.625,7.75,8,8.125,8.25,8.375,8.5,8.625,8.75,9,9.125,9.375,9.5,10,10.5,11,12,13];
    const requested=new URLSearchParams(location.search).get('b_truck_deck');
    const wantedVendors=JSON.parse(select.dataset.truckVendors||'[]');
    const records=Object.entries(window.BeyondTruckFitMap).filter(([id])=>!wantedVendors.length||wantedVendors.includes(window.BeyondTruckVendors[id]));
    widths.forEach(width=>{
      const members=inputs.filter(i=>records.some(([,sizes])=>sizes[i.value]&&width>=sizes[i.value][0]&&width<=sizes[i.value][1]));
      if(!members.length)return;
      const option=document.createElement('option');option.value='__fit_'+width;option.textContent=width+'″';
      option.dataset.fitWidth=String(width);option.dataset.sizeGroup='Fits deck width';option.dataset.sizeValues=JSON.stringify(members.map(i=>i.value));
      option.disabled=members.every(i=>i.disabled);select.append(option);
      if(requested===String(width)&&active.length) select.value=option.value;
    });
    let hidden=form.querySelector('[data-truck-fit-input]');
    if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name='b_truck_deck';hidden.dataset.truckFitInput='';form.append(hidden);}
    hidden.value=select.selectedOptions[0]?.dataset.fitWidth||'';hidden.disabled=!hidden.value;
    select.parentElement.querySelector('small').textContent='Choose your deck width, or use the original truck sizes. Fit is a guide; check shaped decks at the axles.';
  };


  const groupWheelSizes = select => {
    if(select.dataset.sizeScope!=='wheels')return;
    const inputs=[...select.closest('form').querySelectorAll('input[type="checkbox"][name]')].filter(i=>i.name===select.dataset.sizeParam);
    const active=inputs.filter(i=>i.checked).map(i=>i.value);
    const options=[...select.options].filter(o=>o.value&&o.value!=='__multiple');
    const diameter=raw=>{const m=raw.match(/^(\d+(?:\.\d+)?)\s*mm(?:\s*[x×]\s*\d+(?:\.\d+)?\s*mm)?$/i);return m?+m[1]:null;};
    const diameters=[...new Set(inputs.map(i=>diameter(i.value)).filter(n=>n!==null))].sort((a,b)=>a-b);
    const bands=diameters.length>12 ? [
      {label:'Up to 52 mm',test:n=>n<=52},
      {label:'Over 52–54 mm',test:n=>n>52&&n<=54},
      {label:'Over 54–56 mm',test:n=>n>54&&n<=56},
      {label:'Over 56–60 mm',test:n=>n>56&&n<=60},
      {label:'Over 60–64 mm',test:n=>n>60&&n<=64},
      {label:'Over 64 mm',test:n=>n>64}
    ]:diameters.map(n=>({label:n+' mm',test:v=>v===n}));
    const used=new Set();
    bands.forEach(band=>{
      const members=inputs.filter(i=>diameter(i.value)!==null&&band.test(diameter(i.value)));
      const candidates=options.filter(o=>members.some(i=>i.value===o.value));
      if(!candidates.length)return;
      const option=candidates[0];const ds=members.map(i=>diameter(i.value)),lo=Math.min(...ds),hi=Math.max(...ds);option.textContent=(lo===hi?lo:lo+'–'+hi)+' mm';option.dataset.sizeGroup='Wheel diameter';
      option.dataset.sizeValues=JSON.stringify(members.map(i=>i.value));option.disabled=members.every(i=>i.disabled);
      used.add(option);candidates.slice(1).forEach(o=>o.remove());
      if(active.length&&active.every(v=>members.some(i=>i.value===v)))select.value=option.value;
    });
    [...select.options].filter(o=>o.value&&o.value!=='__multiple'&&!used.has(o)).forEach(o=>o.dataset.sizeGroup='Other sizes');
    select.parentElement.querySelector('small').textContent='Diameter in millimetres. Different wheel widths remain included.';
  };

  const viewedSizeGroup = new Map();
  const renderSizeButtons = select => {
    const host = select.parentElement;
    host.querySelector('[data-size-buttons]')?.remove();
    const multi = multiSizeScope(select);
    const chosen = multi ? JSON.parse(select.dataset.clothingSelection || '[]') : [select.value];
    const choices = Array.from(select.options).filter(option => option.value && option.value !== '__multiple' && (!option.disabled || chosen.includes(option.value)));
    host.classList.toggle('beyond-no-sizes', !choices.length);
    if (!choices.length) return;
    const panel = document.createElement('div');
    panel.dataset.sizeButtons = '';
    panel.className = 'beyond-size-buttons';
    const groups = [...new Set(choices.map(option => option.dataset.sizeGroup || 'Sizes'))];
    const selected = select.selectedOptions[0];
    const scope = select.dataset.sizeScope;
    let current = viewedSizeGroup.get(scope) || selected?.dataset.sizeGroup || select.dataset.sizePreferred || groups[0];
    if (!groups.includes(current)) current = groups[0];
    if (groups.length > 1) {
      const tabs = document.createElement('div');
      tabs.className = 'beyond-size-groups';
      tabs.setAttribute('role', 'group');
      tabs.setAttribute('aria-label', 'Sizing system');
      groups.forEach(group => {
        const tab = document.createElement('button');
        tab.type = 'button'; tab.textContent = group;
        tab.setAttribute('aria-pressed', String(group === current));
        tab.addEventListener('click', () => {
          viewedSizeGroup.set(scope, group);
          if (group !== current && chosen.some(Boolean)) {
            select.value = '';
            if (multi) select.dataset.clothingSelection = '[]';
            select.dispatchEvent(new Event('input', {bubbles:true}));
          }
          renderSizeButtons(select);
          [...host.querySelectorAll('.beyond-size-groups button')].find(button => button.textContent === group)?.focus();
        });
        tabs.append(tab);
      });
      panel.append(tabs);
    }
    const grid = document.createElement('div');
    grid.className = 'beyond-size-grid';
    if (current === 'Waist / length' || current === 'Other sizes' || current === 'Deck width' || current === 'Fits deck width' || current === 'Truck size' || current === 'Wheel diameter') grid.style.gridTemplateColumns = 'repeat(3,minmax(0,1fr))';
    grid.setAttribute('role','group');
    grid.setAttribute('aria-label', current === 'Sizes' ? 'Choose size' : current + ' sizes');
    choices.filter(option => (option.dataset.sizeGroup || 'Sizes') === current).sort((a,b) => current === 'Deck width' ? deckNumber(a.value) - deckNumber(b.value) : 0).forEach(option => {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = option.textContent;
      button.disabled = option.disabled && !chosen.includes(option.value);
      button.dataset.sizeValue = option.value;
      button.setAttribute('aria-label', (option.dataset.sizeGroup || 'Size') + ' ' + option.textContent);
      button.setAttribute('aria-pressed', String(chosen.includes(option.value)));
      button.addEventListener('click', () => {
        viewedSizeGroup.set(scope, current);
        if (multi) {
          const values = JSON.parse(select.dataset.clothingSelection || '[]');
          select.dataset.clothingSelection = JSON.stringify(values.includes(option.value) ? values.filter(value => value !== option.value) : [...values,option.value]);
          select.value = JSON.parse(select.dataset.clothingSelection)[0] || '';
        } else select.value = select.value === option.value ? '' : option.value;
        select.dispatchEvent(new Event('input', {bubbles:true}));
        renderSizeButtons(select);
      });
      grid.append(button);
    });
    panel.append(grid);
    if (chosen.some(Boolean)) {
      const clear = document.createElement('button');
      clear.type = 'button'; clear.className = 'beyond-size-clear';
      clear.textContent = multi ? 'Clear sizes · ' + chosen.map(value => sizeSelectionLabel(select, value)).join(', ') : select.value === '__multiple' ? 'Clear selected sizes' : 'Clear size · ' + (selected?.dataset.sizeGroup || '') + ' ' + selected.textContent;
      clear.addEventListener('click', () => {
        select.value = '';
        if (multi) select.dataset.clothingSelection = '[]';
        select.dispatchEvent(new Event('input', {bubbles:true}));
        renderSizeButtons(select);
      });
      panel.append(clear);
    }
    select.hidden = true;
    select.after(panel);
  };
  window.beyondRefreshSize = () => {
    document.querySelectorAll('[data-beyond-size]').forEach(select => {
      [...select.options].filter(option => /^o[\s\/-]*s$/i.test(option.value.trim())).forEach(option => option.remove());
      foldTallSizes(select);
      foldYouthFour(select);
      groupFootwearSizes(select);
      groupDeckSizes(select);
      if(select.dataset.sizeScope==='completes'){
        [...select.options].filter(o=>o.dataset.sizeGroup==='Board length').forEach(o=>o.textContent=parseFloat(o.value)+'″');
        select.parentElement.querySelector('small').textContent='Deck widths in inches. Longer cruiser and longboard labels are shown separately under Board length.';
      }
      groupTruckSizes(select);
      groupWheelSizes(select);
      if (select.dataset.sizeScope === 'footwear') {
        const inputs = [...select.closest('form').querySelectorAll('input[type="checkbox"][name]')].filter(input => input.name === select.dataset.sizeParam);
        const active = [...new Set(inputs.filter(input => input.checked).map(input => input.value))];
        const choices = [...select.options].filter(option => option.value && option.value !== '__multiple');
        let requested = [];
        try { requested = JSON.parse(new URLSearchParams(location.search).get('b_footwear_sizes') || '[]'); } catch {}
        requested = Array.isArray(requested) ? requested.filter(value => choices.some(option => option.value === value)) : [];
        const requestedRaw = [...new Set(requested.flatMap(value => {
          const option = choices.find(option => option.value === value);
          return JSON.parse(option.dataset.sizeValues || JSON.stringify([value]));
        }))].filter(value => inputs.some(input => input.value === value && !input.disabled));
        const exact = requestedRaw.length === active.length && active.every(value => requestedRaw.includes(value));
        const selected = exact ? requested : active.map(value => /^Y\s*-?\s*4(?:\.0+)?$/i.test(value) ? '__youth_4' : value).filter(value => choices.some(option => option.value === value));
        select.dataset.clothingSelection = JSON.stringify([...new Set(selected)]);
        select.value = selected[0] || '';
        let hidden = select.closest('form').querySelector('[data-footwear-size-input]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'b_footwear_sizes';
          hidden.dataset.footwearSizeInput = '';
          select.closest('form').append(hidden);
        }
        hidden.value = JSON.stringify(selected);
        hidden.disabled = !selected.length;
      }
      select.dataset.sizeSelectionLabels = JSON.stringify(JSON.parse(select.dataset.clothingSelection || '[]').map(value => sizeSelectionLabel(select, value)));
      renderSizeButtons(select);
      const note = select.parentElement.querySelector('small');
      if (note && select.dataset.sizeScope === 'footwear') {
        const selected = select.selectedOptions[0];
        note.textContent = 'Choose one or more sizes. Results match any selected size. Switching size groups clears your previous sizes. Check the product’s size guide.';
      }
      if (note && clothingScope(select)) note.textContent = 'Choose one or more sizes. Results match any selected size. Combined sizes are included; check the exact fit on the product.';
      const button = select.parentElement.querySelector('[data-beyond-saved-size]');
      let saved = [];
      try {
        const raw = sessionStorage.getItem(key(select.dataset.sizeScope)) || '';
        try { saved = JSON.parse(raw); } catch { saved = raw ? [raw] : []; }
      } catch {}
      if (!Array.isArray(saved)) saved = [String(saved)];
      saved = saved.filter(value => [...select.options].some(option => option.value === value && !option.disabled));
      const current = multiSizeScope(select) ? JSON.parse(select.dataset.clothingSelection || '[]') : [select.value];
      button.hidden = !saved.length || saved.length === current.length && saved.every(value => current.includes(value));
      if (!button.hidden) {
        button.textContent = 'Use saved ' + (saved.length > 1 ? 'sizes ' : 'size ') + saved.map(value => sizeSelectionLabel(select, value)).join(', ');
        button.dataset.values = JSON.stringify(saved);
      }
    });
    window.beyondRefreshFilters?.();
  };
  document.addEventListener('input', event => {
    const select = event.target;
    if (!select.matches('[data-beyond-size]')) {
      if (select.matches('input[type="checkbox"][name]')) {
        const form = select.closest('form');
        const quick = form?.querySelector('[data-beyond-size]');
        if (quick && quick.dataset.sizeParam === select.name) {
          const active = Array.from(form.querySelectorAll('input[type="checkbox"][name]')).filter(input => input.name === select.name && input.checked);
          quick.value = active.length > 1 ? '__multiple' : active[0]?.value || '';
        }
      }
      return;
    }
    if (select.value === '__multiple') return;
    if(select.dataset.sizeScope==='trucks'){
      const hidden=select.closest('form').querySelector('[data-truck-fit-input]');
      if(hidden){hidden.value=select.selectedOptions[0]?.dataset.fitWidth||'';hidden.disabled=!hidden.value;}
    }
    const form = select.closest('form');
    const chosen = multiSizeScope(select) ? JSON.parse(select.dataset.clothingSelection || '[]') : [select.value];
    const values = [...new Set(chosen.flatMap(value => {
      const option = [...select.options].find(option => option.value === value);
      return JSON.parse(option?.dataset.sizeValues || JSON.stringify([value]));
    }))];
    const clothingInput = form.querySelector('[data-clothing-size-input],[data-footwear-size-input]');
    if (clothingInput) { clothingInput.value = JSON.stringify(chosen); clothingInput.disabled = !chosen.length; }
    form.querySelectorAll('input[type="checkbox"][name]').forEach(input => {
      if (input.name === select.dataset.sizeParam) {
        input.checked = values.includes(input.value) && !input.disabled;
      }
    });
    try {
      if (select.value) sessionStorage.setItem(key(select.dataset.sizeScope), multiSizeScope(select) ? JSON.stringify(chosen) : select.value);
      else sessionStorage.removeItem(key(select.dataset.sizeScope));
    } catch {}
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-beyond-saved-size]');
    if (!button) return;
    const select = button.parentElement.querySelector('[data-beyond-size]');
    const saved = JSON.parse(button.dataset.values || '[]');
    select.value = saved[0] || '';
    if (multiSizeScope(select)) select.dataset.clothingSelection = JSON.stringify(saved);
    select.dispatchEvent(new Event('input', {bubbles:true}));
  });
  window.beyondRefreshSize();
}
